// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pdMcM","label":"styles_label__LRU3_"};